import TownBuyerLandingPage from "./TownBuyerLandingPage";
const BlackwoodLanding = () => (
  <TownBuyerLandingPage townName="Blackwood" slug="homes-for-sale-blackwood" savedLinkId="10354" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-blackwood-ac" />
);
export default BlackwoodLanding;
